export const getDaysInMonth = (month: number, year: number): number => {
  return new Date(year, month, 0).getDate()
}

export const isValidCalendarDate = (month: number, day: number, year: number): boolean => {
  if (!Number.isInteger(month) || !Number.isInteger(day) || !Number.isInteger(year)) {
    return false
  }
  if (month < 1 || month > 12 || day < 1 || year < 1000 || year > 9999) {
    return false
  }
  return day <= getDaysInMonth(month, year)
}

export const clampDayToMonth = (month: number, day: number, year: number): number => {
  const maxDay = getDaysInMonth(month, year)
  return Math.min(Math.max(day, 1), maxDay)
}
